import { differenceInDays, subDays } from "date-fns";

/**
 * Returns the {startDate: Date; endDate: Date; }
 * @param {Date} startDate
 * @param {Date} endDate
 * @return startDate: subtract amount days from startDate
 * @return endDate: Subtract amount days from endDate
 */
export const makeSubDateRange = (startDate: Date | string, endDate: Date | string) => {
  const amount = differenceInDays(new Date(endDate), new Date(startDate));
  const newStartDate = subDays(new Date(startDate), amount + 1);
  const newEndDate = subDays(new Date(endDate), amount + 1);
  return {
    startDate: newStartDate,
    endDate: newEndDate,
  };
};
